var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-sm table-hover" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v("Препарат")]),
            _vm._v(" "),
            _c("th", [_vm._v("Количество")]),
            _vm._v(" "),
            _vm._l(_vm.suppliers, function (supp) {
              return _c("th", [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: supp.title,
                        expression: "supp.title",
                      },
                    ],
                    staticClass: "badge badge-dark pointer",
                  },
                  [_vm._v(_vm._s(supp.title[0]))]
                ),
              ])
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.records, function (record, i) {
          return _c(
            "tr",
            [
              _c("td", [_vm._v(_vm._s(i + 1))]),
              _vm._v(" "),
              _c(
                "td",
                [_c("DrugTitleView", { attrs: { drug: record.drug } })],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _vm._v("\n        " + _vm._s(+record.qty) + "\n      "),
              ]),
              _vm._v(" "),
              _vm._l(_vm.suppliers, function (supp) {
                return _c("td", [
                  record.price_data &&
                  record.price_data.prices &&
                  record.price_data.prices[supp.id]
                    ? _c("div", [
                        _c("p", [
                          _vm._v(
                            _vm._s(record.price_data.prices[supp.id].price) +
                              "\n              "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `https://${
                                  record.price_data.prices[supp.id].priceUrl
                                }`,
                                target: "_blank",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-external-link",
                              }),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }